// Margin by which a server row's createdAt must EXCEED the local save
// timestamp to count as a genuine external (Gmail web) edit. The backend's
// own echo of a save is always a little OLDER than the local commit that
// triggered it (its createdAt is the API Lambda's own clock when it called
// Gmail, which happens after the local save), so anything within this
// margin is our own echo, not confirmation.
export const CONFIRMATION_CLOCK_SKEW_MS = 30_000;

// After this long since the last local save with no confirming external
// edit, the server becomes the truth again regardless of freshness: a
// present server row wins outright, an absent one drops the local row. Also
// what eventually clears a draft deleted in Gmail web, since a delete there
// never produces a confirming row.
export const UNCONFIRMED_DRAFT_TTL_MS = 15 * 60_000;
